import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconMoreHoriz.tsx
const OutlinedFilledMoreHoriz = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z" })
});
const OutlinedMoreHoriz = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z" })
});
const RoundedFilledMoreHoriz = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z" })
});
const RoundedMoreHoriz = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z" })
});
const SharpFilledMoreHoriz = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z" })
});
const SharpMoreHoriz = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M184.78-421q-23.78 0-41.28-17.3T126-479.89Q126-505 143.37-522q17.38-17 41.77-17 23.46 0 41.66 16.89 18.2 16.9 18.2 41.5 0 24.61-18.22 42.11-18.21 17.5-42 17.5Zm295.83 0q-24.61 0-42.11-17.3T421-479.89Q421-505 438.3-522t41.59-17Q505-539 522-522.11q17 16.9 17 41.5 0 24.61-16.89 42.11-16.9 17.5-41.5 17.5Zm294.28 0q-24.82 0-42.35-17.3Q715-455.6 715-479.89 715-505 732.68-522q17.67-17 42.5-17 24.82 0 42.32 16.89 17.5 16.9 17.5 41.5 0 24.61-17.64 42.11T774.89-421Z" })
});
const componentMap = {
	outlined: OutlinedMoreHoriz,
	"outlined-fill": OutlinedFilledMoreHoriz,
	rounded: RoundedMoreHoriz,
	"rounded-fill": RoundedFilledMoreHoriz,
	sharp: SharpMoreHoriz,
	"sharp-fill": SharpFilledMoreHoriz
};
const IconMoreHoriz = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconMoreHoriz };